module.exports = __webpack_public_path__ + "static/media/noun_X_1890803_1.64a70195.svg";